import React from 'react';

const FreelanceSuccess = () => {
  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <h1 style={styles.heading}>🤝 Thank You for Your Inquiry!</h1>
        <p style={styles.message}>
          We appreciate your interest in working with us. If your request aligns with our services and availability, we’ll reach out shortly.
        </p>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '60px 20px',
    background: '#eef6f9', // Light blue-gray tone
    minHeight: '60vh',
  },
  card: {
    background: '#ffffff',
    padding: '40px 30px',
    borderRadius: '12px',
    boxShadow: '0 8px 16px rgba(0,0,0,0.08)',
    textAlign: 'center',
    maxWidth: '520px',
    width: '100%',
  },
  heading: {
    fontSize: '26px',
    color: '#0077b6', // Professional blue
    marginBottom: '12px',
  },
  message: {
    fontSize: '18px',
    color: '#444',
  },
};

export default FreelanceSuccess;
